import { Card } from '@/components/ui/card';

export interface SectorGroupItem {
  name: string;
  percentage: number;
}

export interface SectorAllocationCardProps {
  groups: SectorGroupItem[];
}

export function SectorAllocationCard(props: SectorAllocationCardProps) {
  const { groups } = props;

  const sorted = [...groups].sort((a, b) => b.percentage - a.percentage);

  return (
    <Card className="p-6" data-test-id="sector-allocation-card">
      <h3
        className="text-lg font-semibold text-gray-900 mb-4"
        data-test-id="sector-allocation-title"
      >
        Sector Allocation
      </h3>
      <div className="space-y-3" data-test-id="sector-allocation-list">
        {sorted.map((group) => (
          <div
            key={group.name}
            className="flex items-center justify-between"
            data-test-id={`sector-item-${group.name.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
          >
            <span
              className="text-sm font-medium text-gray-700"
              data-test-id="sector-label"
            >
              {group.name}
            </span>
            <div className="flex items-center space-x-2">
              <div
                className="w-24 bg-gray-200 rounded-full h-2"
                data-test-id="sector-progress-bar"
              >
                <div
                  className="bg-blue-600 h-2 rounded-full"
                  style={{ width: `${group.percentage}%` }}
                ></div>
              </div>
              <span
                className="text-sm text-gray-600 w-12 text-right"
                data-test-id="sector-percentage"
              >
                {group.percentage.toFixed(1)}%
              </span>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
